<div class="wrapper modal">
  <div
    class="toggleAll checkItem c-bd-bottom c-m-bottom-md"
    data-automation-e2e-selector="exportOption"
  >
    <div class="c-checkbox c-m-bottom-sm">
      <input
        type="checkbox"
        id="all"
        [ngModel]="isAllSelected()"
        (change)="toggleAll($event)"
        data-automation-e2e-selector="exportOptionCheckbox"
      />
      <label for="all" data-automation-e2e-selector="exportOptionText"
        ><b>Select All</b></label
      >
    </div>
  </div>
  <div class="options">
    <div
      class="allOrders checkItem"
      data-automation-e2e-selector="exportOption"
    >
      <div class="c-checkbox c-m-bottom-md">
        <input
          type="checkbox"
          id="orders"
          (change)="toggleReportInExport(reportType.AllOrders)"
          [ngModel]="getCheckboxValue(reportType.AllOrders)"
          data-automation-e2e-selector="exportOptionCheckbox"
        />
        <label for="orders" data-automation-e2e-selector="exportOptionText">
          <b>All Orders</b>
          <p>Export a list of all orders in a single tab</p>
        </label>
      </div>
    </div>
    <div
      class="orderMonitor checkItem"
      data-automation-e2e-selector="exportOption"
    >
      <div class="c-checkbox c-m-bottom-md">
        <input
          type="checkbox"
          id="om"
          (change)="toggleReportInExport(reportType.OrderMonitor)"
          [ngModel]="getCheckboxValue(reportType.OrderMonitor)"
          data-automation-e2e-selector="exportOptionCheckbox"
        />
        <label for="om" data-automation-e2e-selector="exportOptionText">
          <b>Order Monitor <span class="disclaimer-note">*</span></b>
          <p>
            Export the order summary table as Overview, Retail & Priority tabs
            (if applicable)
          </p>
        </label>
      </div>
    </div>
    <div
      class="managersReports checkItem"
      data-automation-e2e-selector="exportOption"
    >
      <div class="c-checkbox c-m-bottom-md">
        <input
          type="checkbox"
          id="mr"
          (change)="toggleReportInExport(reportType.ManagersReport)"
          [ngModel]="getCheckboxValue(reportType.ManagersReport)"
          data-automation-e2e-selector="exportOptionCheckbox"
        />
        <label for="mr" data-automation-e2e-selector="exportOptionText">
          <b>Managers Report <span class="disclaimer-note">*</span></b>
          <br />
          <p>
            Export order summary reports by syndicate as Overview & Retail tabs
            (if applicable)
          </p>
        </label>
      </div>
    </div>
    <div
      class="accountsReport checkItem"
      data-automation-e2e-selector="exportOption"
    >
      <div class="c-checkbox c-m-bottom-md">
        <input
          type="checkbox"
          id="acounts"
          (change)="toggleReportInExport(reportType.AccountsReport)"
          [ngModel]="getCheckboxValue(reportType.AccountsReport)"
          [attr.disabled]="(hasAccountsPermissions | async) ? null : ''"
          data-automation-e2e-selector="exportOptionCheckbox"
        />
        <label for="acounts" data-automation-e2e-selector="exportOptionText">
          <b>Accounts Report <span class="disclaimer-note">*</span></b>
          <br />
          <p>Export order summary report by account(s)</p>
        </label>
      </div>
    </div>
  </div>
  <div
    *ngIf="isError$ | async"
    class="c-alert c-alert-danger"
    data-automation-e2e-selector="exportErrorMessage"
  >
    <a
      class="c-a c-alert-close"
      data-dismiss="c-alert"
      aria-hidden="true"
      (click)="setErrorState(false)"
      data-automation-e2e-selector="closeErrorMessage"
    >
      <i class="fa fa-times" aria-hidden="true"></i>
    </a>
    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
    <strong>Please select at least one report to export.</strong>
  </div>
  <div class="actions">
    <button
      type="button"
      class="c-btn c-btn-secondary c-m-right-sm"
      (click)="closeModal()"
      data-automation-e2e-selector="cancelButton"
    >
      Cancel
    </button>
    <button
      type="button"
      class="c-btn c-btn-primary"
      (click)="exportReports()"
      data-automation-e2e-selector="exportButton"
    >
      Export
    </button>
  </div>
  <div class="disclaimer">
    <span class="disclaimer-note">*</span>
    Note: Any Gameday filters applied at the time of export are reflected in the
    exported data of this report. To ensure a complete data set, please clear
    all filters before exporting.
  </div>
</div>
